export class InfosHelper {

  public static buildRegExpValidRegistro(unidade): RegExp {
    if (!unidade || !unidade.registroValidacaoRegexp || !unidade.registroValidacaoExplic) {
      return null;
    }
    var match = unidade.registroValidacaoRegexp.match(new RegExp('^/(.*?)/([gimy]*)$'));
    return new RegExp(match[1], match[2]);
  }


  public static validRegistro(valor: string, unidade: any, regexpRegistro: RegExp) {
    if (!unidade || !unidade.campoRegistroObrigatorio) {
      return true;
    }
    if (!valor) {
      return 'Informe o registro';
    }

    if (regexpRegistro && unidade.registroValidacaoExplic && !valor.match(regexpRegistro)) {
      return unidade.registroValidacaoExplic;
    }

    return true;
  }
}